export const DEG_TO_RAD = Math.PI / 180;
const DEFAULT_SLOPE = 2;
export const DEFAULT_SKEW = Math.atan(1 / DEFAULT_SLOPE);

export function getHorizontalOffset(height: number = 1) {
  return height / DEFAULT_SLOPE;
}
